// ============================================
// COSMIC HINDU - Entry Point
// ============================================

import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { CartProvider } from '@context/CartContext';
import { AuthProvider } from '@context/AuthContext';
import { WishlistProvider } from '@context/WishlistContext';
import { DiscountProvider } from '@context/DiscountContext';
import './index.css';

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <DiscountProvider>
          <CartProvider>
            <WishlistProvider>
              <App />
            </WishlistProvider>
          </CartProvider>
        </DiscountProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
